import { render, staticRenderFns } from "./driverassets.html?vue&type=template&id=88487198&scoped=true&external"
import script from "./driverassets.vue?vue&type=script&lang=js"
export * from "./driverassets.vue?vue&type=script&lang=js"
import style0 from "./driverassets.vue?vue&type=style&index=0&id=88487198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88487198",
  null
  
)

export default component.exports